<template>
  <div class="animated fadeIn">
    <h3>Feed Report</h3>
    <b-card v-for="(sample, index) in samples" no-body :key="index">
      <b-card-header>
        <span class="text-muted">
          <b>Sample</b>: {{ sample.number }} | <b>ID</b>: {{ sample.id }} |
          <b>Type</b>: {{ sample.type }}
        </span>
      </b-card-header>
      <b-card-body class="p-0">
        <b-table
          class="mb-0"
          :items="sample.analyses"
          :fields="columns"
          responsive
          bordered
        >
          <template #cell(range)="data">
            <report-progress-bar
              :result="data.item.as_fed_result"
              :low="data.item.range.low"
              :high="data.item.range.high"
            />
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ReportProgressBar from "@/components/shared/ReportProgressBar";

export default {
  name: "SubmissionFeedReport",
  components: { ReportProgressBar },
  props: {
    samples: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        { key: "name", label: "Analysis" },
        { key: "dry_result", label: "Dry Basis Result" },
        { key: "as_fed_result", label: "As Fed Result" },
        { key: "unit", label: "Units" },
        { key: "range", label: "Feed Sufficiency Range" },
      ],
    };
  },
};
</script>
